import React from 'react';
import TellurideEvents from './components/TellurideEvents';

function App() {
  return (
    <div className="App">
      <TellurideEvents />
    </div>
  );
}

export default App;